//Libs
import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

// Hooks
import useUser from '../../../hooks/useUser';
import useUI from '../../../hooks/useUI';
import { useStyles } from './OrderIdLinkStyles';

const OrderIdLink = ({ order }) => {
  const { isKiteUser } = useUser();
  const { isDesktopMode, isTabletMode, isMobileMode } = useUI();
  const { classes } = useStyles({ isKiteUser, isTabletMode, isMobileMode });

  const isDistro = useMemo(
    () => !!order?.addresses?.length && !order.parent,
    [order?.addresses?.length, order.parent],
  );

  return (
    <div className={classes.relative} data-testid={'order-id-link'}>
      <Typography
        component={Link}
        title={order.order_sn}
        to={`${order.id}`}
        className={classes.linkText}>
        {!isDesktopMode && 'Order ID: '}#{order.order_sn}
      </Typography>
      {isDistro && isDesktopMode && (
        <span className={classes.caption}>Distro</span>
      )}
    </div>
  );
};

export default OrderIdLink;
